import { Optional } from '@angular/core';
import { Observable } from 'rxjs';

import { ExecutorService, ExecutorOptions, removeRedundantSlashesFromPath } from './executor.service';
import { ApiConfiguration, apiRootForService, defaultApiConfiguration } from './model/api-configuration';

export class SharedApiExecutorService {
    private readonly apiRoot: string;

    constructor(
        private readonly apiName: keyof ApiConfiguration,
        private readonly executor: ExecutorService,
        @Optional() config: ApiConfiguration | null,
    ) {
        this.apiRoot = apiRootForService(this.apiName, config || defaultApiConfiguration);
    }

    invokeServiceWithParams<T>(
        url: string,
        params?: Record<string, unknown>,
        options?: ExecutorOptions,
    ): Observable<T> {
        return this.executor.invokeServiceWithParams(`${this.apiRoot}/${removeRedundantSlashesFromPath(url)}`, params, options);
    }

    invokeServiceWithBody<T>(
        url: string,
        method: string,
        body: unknown,
        options?: ExecutorOptions,
    ): Observable<T> {
        return this.executor.invokeServiceWithBody(`${this.apiRoot}/${removeRedundantSlashesFromPath(url)}`, method, body, options);
    }
}
